import { render } from "./DeleteVideo.vue?vue&type=template&id=d066bff6&scoped=true"
import script from "./DeleteVideo.vue?vue&type=script&lang=js"
export * from "./DeleteVideo.vue?vue&type=script&lang=js"

import "./DeleteVideo.vue?vue&type=style&index=0&id=d066bff6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d066bff6"]])

export default __exports__